import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=26177970&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"
import style0 from "./Terms.vue?vue&type=style&index=0&id=26177970&prod&lang=css"
import style1 from "./Terms.vue?vue&type=style&index=1&id=26177970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26177970",
  null
  
)

export default component.exports